
  // GWP Configuration
  const gwpConfig = {
    enabled: true,
    threshold: 60.0, // Price threshold in dollars
    gwpVariantId: 45370489045170,
    gwpQuantity: 1,
  };

//     product_id: 8398964326578
// form_type: product
// utf8: ✓
// id: 45063475036338
  // Function to check and manage GWP
function manageGWP(cart) {
  console.log("manage");

  if (!gwpConfig.enabled) return;

  let adjustedTotal = cart.total_price / 100; // Convert cents to dollars

  // Find the GWP item if it exists
  const gwpItem = cart.items.find(
    (item) => item.variant_id === gwpConfig.gwpVariantId
  );

  const hasGWP = !!gwpItem;

  // Subtract GWP price if present and price > 0
  if (hasGWP && gwpItem.final_price > 0) {
    const gwpPrice = gwpItem.final_price * gwpItem.quantity / 100;
    adjustedTotal -= gwpPrice;
    console.log(`Adjusted total after removing GWP price ($${gwpPrice}): $${adjustedTotal}`);
  }

  console.log("has GWP:", hasGWP);
  console.log("threshold:", gwpConfig.threshold);
  console.log("adjustedTotal:", adjustedTotal);

  if (adjustedTotal >= gwpConfig.threshold && !hasGWP) {
    // Add GWP
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: gwpConfig.gwpVariantId,
        quantity: 1,
      },
      dataType: "json",
      success: function () {
        console.log("GWP added:", gwpConfig.gwpVariantId);
        cartdrawerSetResponce();
      },
      error: function () {
        console.log("Error adding product to cart");
      },
    });
  } else if (adjustedTotal < gwpConfig.threshold && hasGWP) {
    // Remove GWP
    if (gwpItem) {
      console.log("Removing GWP due to threshold drop");
      removeProductFromCart(gwpItem.key);
    }
  }
}
function cartdrawerSetResponce() {
  console.log('cartdrawer response')
  var saletag_svg =
    '<svg {{ shared_attr }} width="20" height="20" viewBox="0 0 350 350" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 197.826C0 192.95 1.93821 188.275 5.38762 184.83L179.459 10.7587C186.348 3.86966 195.692 -0.000356971 205.435 2.46966e-08H334.782C343.187 2.46966e-08 350 6.81304 350 15.2173V144.565C350 154.308 346.13 163.651 339.241 170.541L165.17 344.612C161.725 348.061 157.049 350 152.174 350C147.299 350 142.624 348.061 139.179 344.612L5.38762 210.821C1.93821 207.376 0 202.701 0 197.826ZM304.348 68.4786C304.348 81.085 294.128 91.3046 281.521 91.3046C268.915 91.3046 258.695 81.085 258.695 68.4786C258.695 55.8721 268.915 45.6525 281.521 45.6525C294.128 45.6525 304.348 55.8721 304.348 68.4786Z" fill="currentColor"/></svg>';

  $.getJSON("/cart.js", function (cart) {
    // Check and manage GWP
    manageGWP(cart);

    var size = cart.item_count;

    var cart_total_price = cart.total_price;

    $(".cart-count-number").html(parseInt(size));

    var article = "";

    $(cart.items).each(function (index, item) {
      var item_has_discounts = false;
      if (item.line_level_discount_allocations.length > 0) {
        item_has_discounts = true;
      }

      var bundle_id = 0;
      if (item.properties) {
        $.each(item.properties, function (key, property) {
          if (key == "_free") {
            bundle_id = item.id;
            return false;
          }
        });
      }

      article +=
        `<article class="${
          item.vendor === "Order Protection" ? "hidden" : ""
        } mini-cart-item removevariant_` +
        item.id +
        '" data-variant="' +
        item.id +
        '"';
      article += 'data-url="' + item.url + '"';
      article += 'data-title="' + item.handle + '">';

      article += '<figure class="mini-cart-item-image">';
      article += '<a href="' + item.url + '">';
      article +=
        '<img src="' +
        imgURL(item.featured_image.url, "100x") +
        '"></a></figure>';

      article += '<div class="mini-cart-item-details">';
      article += '<p class="mini-cart-item-title">';
      article += '<a href="' + item.url + '">' + item.product_title;
      if (item.variant_options != "Default Title") {
        article += "(" + item.variant_title + ")";
      }
      article += "</p>";

      let itemProp = item.properties;
      if (!$.isEmptyObject(item.properties)) {
        $.each(itemProp, function (property) {
          // do something with `property`

          if (!$.isEmptyObject(property.last)) {
            article += '<p class="mini-cart-item-property">';
            article +=
              '<span class="property-label">' + property.first + "</span>";
            if (property.last("/uploads/") != -1) {
              article +=
                '<a class="property-image" href="' + property.last + '">';
              let last = property.last.split("/").pop();
              article += last + "</a>";
            } else {
              article +=
                '<span class="property-value">' + property.last + "</span>";
            }
            article += "</p>";
          }
        });
      }

      if (item_has_discounts == true) {
        article += '<s class="original-price">';
        article +=
          '<span class="money">' +
          Shopify.formatMoney(item.original_price, "${{amount}}") +
          "</span>";
        article += "</s>";
      }

      if (bundle_id == 0) {
        article +=
          '<span class="cart-item-price money" data-cart-item-subtotal>';
        article +=
          '<span class="saso-cart-item-price" data-key="' +
          item.key +
          '"></span>';
        article += "</span>";
      }

      article += '<p class="mini-cart-item-price">';
      article +=
        '<span class="final-price money "><s>' +
        Shopify.formatMoney(item.final_price, "${{amount}}") +
        "</s></span>";
      article +=
        '<span class="final-price money two">' +
        Shopify.formatMoney(item.final_price, "${{amount}}") +
        "</span>";
      article += "</p>";

      // unit price logic not applyed from mini-cart

      article += '<div class="quantity">';
      if (bundle_id == 0) {
        article += '<div class="qtydiv">';
        article += '<div class="qtybox">';
        article +=
          '<span class="btnqty qtyminus icon icon-minus" data-unit-price="' +
          Shopify.formatMoney(item.final_price, "${{amount}}") +
          '" data-product-id="' +
          item.variant_id +
          '" >-</span>';
        article +=
          '<input type="text" id="updates_' +
          item.key +
          '" name="quantity" value="' +
          item.quantity +
          '" data-product-id="' +
          item.product_id +
          '" data-quantity-key="' +
          item.key +
          '"';
        article +=
          'class="quantity-selector qty_custom_' +
          item.variant_id +
          " quantity-input variant_id_" +
          item.variant_id +
          '" readonly="">';
        article +=
          '<span class="btnqty qtyplus icon icon-plus" data-unit-price="' +
          Shopify.formatMoney(item.final_price, "${{amount}}") +
          '" data-product-id="' +
          item.variant_id +
          '">+</span>';
        article += "</div>";
        article += "</div>";
      } else {
        article += '<p class="mini-cart-item-quantity">Qty: <span>1</span></p>';
      }

      article +=
        '<a href="#" class="remove remove-variant" data-product-id="' +
        item.variant_id +
        '" data-remove-item="' +
        item.key +
        '">Remove</a>';

      article += "</div>";
      if (item_has_discounts == true) {
        if (!$.isEmptyObject(item.line_level_discount_allocations)) {
          article += '<ul class="cart-item-discounts">';

          $.each(
            item.line_level_discount_allocations,
            function (key, discount_allocation) {
              article += saletag_svg;
              if (
                !$.isEmptyObject(discount_allocation.discount_application.title)
              ) {
                article += discount_allocation.discount_application.title;
              }
              article +=
                '(-<span class="money">' +
                Shopify.formatMoney(discount_allocation.amount, "${{amount}}") +
                "</span>)";
            },
          );

          article += "<ul>";
        }
      }

      article += "</div>";
      article += "</article>";
    });

    // Add cart total price to checkout button for cart drawer
    $(".custom-subtotal").html(
      Shopify.formatMoney(cart_total_price, "${{amount}}"),
    );

    $(".refresh_cart_drawer").html(article);
  });

  // Open Cart Drawer
  Open_mini_cart();
}

function removeProductFromCart(line) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: line,
      quantity: 0,
    },
    dataType: "json",
    success: function (cart) {
      cartdrawerSetResponce();
    },
    error: function (XMLHttpRequest) {
      console.log("Error removing product from cart");
    },
  });
}

$(document).ready(function () {
  var saletag_svg =
    '<svg {{ shared_attr }} width="20" height="20" viewBox="0 0 350 350" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 197.826C0 192.95 1.93821 188.275 5.38762 184.83L179.459 10.7587C186.348 3.86966 195.692 -0.000356971 205.435 2.46966e-08H334.782C343.187 2.46966e-08 350 6.81304 350 15.2173V144.565C350 154.308 346.13 163.651 339.241 170.541L165.17 344.612C161.725 348.061 157.049 350 152.174 350C147.299 350 142.624 348.061 139.179 344.612L5.38762 210.821C1.93821 207.376 0 202.701 0 197.826ZM304.348 68.4786C304.348 81.085 294.128 91.3046 281.521 91.3046C268.915 91.3046 258.695 81.085 258.695 68.4786C258.695 55.8721 268.915 45.6525 281.521 45.6525C294.128 45.6525 304.348 55.8721 304.348 68.4786Z" fill="currentColor"/></svg>';
  $(document).on(
    "click",
    ".rebuy-cart__flyout-item-remove, .rebuy-cart__flyout-item-quantity-widget-button, .custom-cart-drawer, .add-to-cart-button, .mini-cart-item-details .qtyplus, .mini-cart-item-details .qtyminus, .mini-cart-item-details .remove, .add-to-cart, .mini-cart-wrapper.custom-cart-drawer",
    function () {
      setTimeout(function () {
        cartdrawerSetResponce();
      }, 1500);
    },
  );

  // Add to cart for single product on cart Drawer By Arctic Grey
  $(document).on("click", ".add-to-cart-refresh", function () {
    var id = $(this).data("variant-id");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: id,
        quantity: 1,
      },
      error: function (data, textstatus) {},
      success: function (data, textstatus) {
        cartdrawerSetResponce();
      },
    });
  });

  // remove product from cart
  // This button will decrement the value till 0
  $(document).on("click", ".remove-variant", function (e) {
    e.preventDefault();
    var variant_id = $(this).attr("data-product-id");
    var custom_cart_count = $(".cart-count-number").html();

    var cart_qty = $(".variant_id_" + variant_id).val();
    var new_custom_cart_count =
      parseInt(custom_cart_count) - parseInt(cart_qty);
    $(".cart-count-number").html(new_custom_cart_count);
    // Stop acting like a button

    // Get the field name

    $.post("/cart/update.js", "updates[" + variant_id + "]=0")
      .done(function () {
        $(".removevariant_" + variant_id).remove();
      })
      .fail(function () {
        console.log("error");
      })
      .always(function (data) {
        var sub_total = JSON.parse(data);
        sub_total = sub_total.items_subtotal_price / 100;
        $(".custom-subtotal").text(
          "$" +
            parseFloat(sub_total, 10)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
              .toString(),
        );

        cartdrawerSetResponce();
      });
  });

  // Handle swatch form submit for add to cart
  $(document).on("submit", "form.swatch-addtocart-form", function (e) {
    // code
    e.preventDefault();
    var form_data = $(this).serialize();
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: form_data,
      success: addToCartWithSwatch,
      error: addToCartFail,
    });
  });
});

function revertBtnToSelectSwatch(article) {
  // Event for swatches hide when click on any other button for choose swatche

  var elems = document.querySelectorAll("article.product-list-item ");

  [].forEach.call(elems, function (el) {
    el.classList.remove("active");
    var current_id = el.getAttribute("id");

    $(".swatches-container").css("height", "0px");

    var frm_btn = el.querySelector(".variant-option-submit");

    if (frm_btn.classList.contains("add-to-cart-refresh") === false) {
      frm_btn.setAttribute("onClick", "starAppsDrawer()");

      var frm_btn_span = frm_btn.querySelector(".label-choose");

      var btn_text = frm_btn_span.getAttribute("data-initial-text");
      var variant_text = frm_btn_span.getAttribute("data-variant-text");

      frm_btn_span.innerHTML = variant_text;

      frm_btn.removeAttribute("disabled");
    }
  });
}

function addToCartWithSwatch(productResponce) {
  if (productResponce) {
    // set cart drawer responce in html
    setTimeout(function () {
      cartdrawerSetResponce();
    }, 1500);
  }
}

function addToCartFail(obj, status) {
  alert("The product you are trying to add is out of stock.");
}

function addProduct(line) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: line,
      quantity: 1,
    },
    dataType: "json",
    success: function (cart) {
      cartdrawerSetResponce();
    },
    error: function (XMLHttpRequest) {
      console.log("Error removing product from cart");
    },
  });
}

function Open_mini_cart() {
  $("body").addClass("overlay");
  $(".mini-cart").addClass("left");
  $(".mini-cart").show("800");
}

// alternatively, if you don't want to use a polyfil
function imgURL(src, size) {
  // remove any current image size then add the new image size
  return src
    .replace(
      /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
      "."
    )
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
      return "_" + size + match;
    });
}

$(document).ready(function () {
  $("body").on("click", ".vario-variant", function () {
    var variant_id = $(this).attr("data-product-id");
  });
});

//career-accordion
$(document).ready(function () {
  $(".accordion-list > li > .inner-info .answer").hide();

  $(".accordion-list > li > .inner-info").click(function () {
    console.log("hello");
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").find(".answer").slideUp();
    } else {
      $(".accordion-list > li.active > .inner-info .answer").slideUp();
      $(".accordion-list > li.active").removeClass("active");
      $(this).addClass("active").find(".answer").slideDown();
    }
    return false;
  });
});

// Add class for the Afterpay in PDP
$(document).ready(async function () {
  async function waitForElement(selector) {
    const element = document.querySelector(selector);
    if (element) return element;
    await new Promise((resolve) => requestAnimationFrame(resolve));
    return waitForElement(selector);
  }

  try {
    const afterpay = await waitForElement("square-placement");
    afterpay?.classList.add("ge-hide-display-none");
  } catch (error) {
    return error;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Function to initialize Swiper
  function initializeSwiper(
    selector,
    paginationClass,
    nextButtonClass,
    prevButtonClass
  ) {
    if (document.querySelector(selector)) {
      new Swiper(selector, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: `.${paginationClass}`,
          clickable: true,
        },
        navigation: {
          nextEl: `.${nextButtonClass}`,
          prevEl: `.${prevButtonClass}`,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });
    }
  }

  // Initialize Swipers with unique classes
  initializeSwiper(
    ".ctm-featured_product",
    "swiper-pagination-one",
    "swiper-button-next-one",
    "swiper-button-prev-one"
  );
  initializeSwiper(
    ".ctm-featured_collection",
    "swiper-pagination-two",
    "swiper-button-next-two",
    "swiper-button-prev-two"
  );
});
